var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn border bg-gray-5 btn-sm btn-block",attrs:{"type":"button","id":_vm.id},on:{"click":function($event){$event.preventDefault();return _vm.action.apply(null, arguments)}}},[_c('span',{staticClass:"small"},[_vm._v(_vm._s(_vm.description))]),_c('img',{staticClass:"float-right",attrs:{"src":_vm.src,"height":"20"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }